module.exports = __webpack_public_path__ + "66d3b46fc646789014a1f732eb68e0bf.fbx";